export default {
  wx: undefined,
  wxConfig: undefined,
  currentTitle: '',
  authInfo: undefined
}
